<template>
    <v-container fluid>

        <div class="centered-content mt-sm-8 mt-md-12">

            <!--Alertes-->
            <v-alert border="left" elevation="2" transition="slide-y-transition" type="error" v-model="error.unknown">
                <div>Une erreur est survenue. Si le problème persiste, contactez le <a
                        href="https://support.yodaforex.com">support Yodaforex</a></div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="submit" text>Réessayer</v-btn>
                    </v-col>
                </v-row>
            </v-alert>

            <v-alert border="left" colored-border elevation="2" transition="slide-y-transition" type="success"
                     v-model="success">
                <div>Votre compte a bien été créé</div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="$router.push({name:'login', params: {login:user.email}})" text>Se connecter
                        </v-btn>
                    </v-col>
                </v-row>
            </v-alert>


            <v-alert border="left" colored-border elevation="2"
                     transition="slide-y-transition"
                     type="warning"
                     v-model="error.expired">
                <div>Votre invitation à rejoindre Yodaforex a expiré. Demandez à la personne qui vous a invité de vous
                    inviter à nouveau.
                </div>
            </v-alert>

            <!--Login form-->
            <v-card :disabled="success || error.expired" :loading="loading">
                <v-card-title class="word-wrap">Inscription à Yodaforex</v-card-title>
                <v-container class="pa-sm-8">
                    <v-form @submit.prevent="submit" ref="loginForm">
                        <v-row>
                            <v-col>
                                <v-text-field :disabled="true" :loading="loading" class="thin-outlined"
                                              hide-details label="Email" outlined v-model="user.email"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field :append-icon="hidePassword ? 'visibility' : 'visibility_off'" :color="passwordStrengthColor"
                                              :disabled="submitting" :type="hidePassword ? 'password' : 'text'"
                                              @click:append="() => (hidePassword = !hidePassword)" class="thin-outlined" hide-details
                                              label="Choissiez un mot de passe" outlined
                                              v-model="password"
                                />
                                <password-strength :password="password" @color="passwordStrengthColor = $event"
                                                   class="mt-2"
                                                   v-model="isPasswordSafe"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn :disabled="!isPasswordSafe" :loading="submitting" block color="success"
                                       type="submit">
                                    Envoyer
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card>
        </div>
    </v-container>
</template>

<script>
	import PasswordStrength from "../../components/PasswordStrength";

	export default {

		name: "InvitationView",
		components: {PasswordStrength},
		data() {
			return {
				token: null,
				loading: false,
				submitting: false,
				user: {email: ""},
				password: "",
				isPasswordSafe: false,
				hidePassword: true,
				passwordStrengthColor: "primary",
				success: false,
				error: {
					expired: false,
					unknown: false
				}
			}
		},
		mounted() {
			this.fetchUserInfo();
		},
		methods: {
			fetchUserInfo() {
				let url = new URL(window.location.origin + window.location.hash.substring(1));
				this.token = url.searchParams.get("token");
				if (!this.token) {
					this.error.unknown = true;
				} else {
					this.$http.post(this.$config.apiUrl + "/v2/userinvitations/contentrequest", {invitationCode: this.token})
						.then(r => this.user = r.data)
						.catch((e) => {
							if (e.response && e.response.status === 400) this.error.expired = true;
							else this.error.unknown = true;
						})
						.finally(() => this.loading = false)
				}
			},
			submit() {
				if (this.isPasswordSafe) {
					this.submitting = true;
					this.error.unknown = false;
					this.$http.post(this.$config.apiUrl + "/v2/userinvitations/acceptationrequest", {
						invitationCode: this.token,
						password: this.password
					})
						.then(r => this.success = true)
						.catch(() => this.error.unknown = true)
						.finally(() => this.submitting = false)
				}
			}
		}
	}
</script>

<style scoped>

    .centered-content {
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
</style>
